import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import AdminLayout from "../component/AdminLayout";

const BookDetail = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const bookData = location.state?.book;
    //  console.log("bookData:::" , bookData)

    const [editing, setEditing] = useState(false);

    // 데이터가 없을 경우 처리
    if (!bookData) {
        return (
            <div className="p-5 text-center">
                <h5>도서 정보를 찾을 수 없습니다.</h5>
                <button className="btn btn-primary" onClick={() => navigate(-1)}>뒤로 가기</button>
            </div>
        );
    }


    const handleSaveStatus = () => {
        setEditing(false);
        alert("도서 상태가 변경되었습니다.");
    };

    const statusMapping: { [key: string]: string } = {
        "PENDING": "승인 대기",
        "ACTIVE": "활성화",
        "SUSPENDED": "반려",
        "HOLD": "비활성화",
    };

    return (
        <AdminLayout
            pageTitle="도서 관리 상세"
            breadcrumbs={[
                { label: 'Home', link: '/admin' },
                { label: 'Book', link: '/adminBook' },
                { label: 'Detail', active: true }
            ]}
        >

            {/* [ Main Content ] */}
            <div className="main-content">
                <div className="row g-4">

                    {/* 왼쪽: 도서 표지 및 기본 상태 카드 */}
                    <div className="col-xxl-3 col-xl-4">
                        <div className="card border-0 shadow-sm h-100">
                            <div className="card-body p-4 text-center">
                                {/* 도서 표지 */}
                                <div className="mx-auto mb-4 border rounded shadow-sm overflow-hidden" style={{ width: '200px', aspectRatio: '2/3' }}>
                                    <img
                                        src={
                                            bookData.coverImage
                                                ? `data:image/jpeg;base64,${bookData.coverImage}`
                                                : 'https://via.placeholder.com/200x300?text=No+Cover'
                                        }
                                        alt="Book Cover"
                                        className="w-100 h-100 object-fit-cover"
                                    />
                                </div>

                                {/* 도서 제목 */}
                                <h5 className="fw-bold mb-1 text-dark">{bookData.bookTitle}</h5>

                                {bookData.bookAwardTitle && (
                                    <div className="mb-4 p-3 rounded-3 bg-soft-warning border border-warning border-opacity-25 text-start">
                                        <div className="d-flex align-items-center mb-2">
                                            <i className="feather-award text-warning me-2"></i>
                                            <span className="fs-11 fw-bold text-warning text-uppercase">Award Winner</span>
                                        </div>
                                        <h6 className="fw-bold text-dark mb-1 fs-14">{bookData.bookAwardTitle}</h6>
                                        <small className="text-muted">{bookData.bookAwardDate}</small>
                                    </div>
                                )}

                                <ul className="list-unstyled text-start mb-4">
                                    <hr className="opacity-50" />
                                    <div className="fs-11 fw-bold text-muted text-uppercase mb-3">Book Info</div>
                                    <li className="mb-2 d-flex justify-content-between">
                                        <span className="text-muted fs-12">등록일</span>
                                        <span className="fs-12">{bookData.createdDate || '-'}</span>
                                    </li>
                                    <li className="mb-2 d-flex justify-content-between">
                                        <span className="text-muted fs-12">장르</span>
                                        <span className="fs-12">{bookData.genre1} / {bookData.genre2}</span>
                                    </li>
                                </ul>

                                {/* 하단 버튼 */}
                                <div className="d-flex gap-2">
                                    <button className="btn btn-outline-primary flex-fill" onClick={() => navigate(-1)}>
                                        <i className="feather-arrow-left me-2"></i>목록으로
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* 오른쪽: 도서 상세 설명 및 메타 정보 */}
                    <div className="col-xxl-9 col-xl-8">
                        <div className="card border-0 shadow-sm">
                            <div className="card-header bg-white border-bottom py-3">
                                <h5 className="mb-0 fw-bold">도서 상세 정보</h5>
                            </div>
                            <div className="card-body p-4">

                                {/* 책 소개 섹션 */}
                                <div className="mb-5">
                                    <h5 className="fw-bold mb-3 d-flex align-items-center">
                                        <span className="bg-primary rounded me-2" style={{ width: '4px', height: '18px' }}></span>
                                        책 소개
                                    </h5>
                                    <div className="bg-light p-4 rounded-3 text-dark lh-base" style={{ whiteSpace: 'pre-wrap' }}>
                                        {bookData.bookDescription || "등록된 소개글이 없습니다."}
                                    </div>
                                </div>

                                {/* 키워드 및 추가 정보 */}
                                {/* 키워드 및 선정 이유 섹션 */}
                                <div className="mb-5">
                                    <h5 className="fw-bold mb-3 d-flex align-items-center">
                                        <span className="bg-primary rounded me-2" style={{ width: '4px', height: '18px' }}></span>
                                        출간 계기
                                    </h5>
                                    <div className="border rounded-3 p-4 bg-white shadow-sm" style={{ borderLeft: '4px solid #6366f1' }}>
                                        <p className="text-dark lh-lg mb-0" style={{ whiteSpace: 'pre-wrap', fontSize: '14px' }}>
                                            {bookData.bookPublicationReason || "등록된 출간 계기 정보가 없습니다."}
                                        </p>
                                    </div>

                                    <div className="row g-3">
                                        {[
                                            { kw: bookData.keyword1, reason: bookData.keyword1Reason, label: '키워드 1' },
                                            { kw: bookData.keyword2, reason: bookData.keyword2Reason, label: '키워드 2' },
                                            { kw: bookData.keyword3, reason: bookData.keyword3Reason, label: '키워드 3' }
                                        ].map((item, index) => (
                                            <div className="col-12" key={index}>
                                                <div className="p-3 rounded-3 border-start border-4 border-primary bg-white shadow-sm">
                                                    <div className="d-flex align-items-center mb-2">
                                                        <span className="badge bg-soft-primary text-primary me-2">#{item.kw || '미지정'}</span>
                                                        <small className="text-muted fw-bold">{item.label}</small>
                                                    </div>
                                                    <div className="ps-2">
                                                        <p className="mb-0 text-dark fs-13" style={{ whiteSpace: 'pre-wrap' }}>
                                                            {item.reason ? item.reason : "등록된 이유가 없습니다."}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </AdminLayout>
    );
};

export default BookDetail;